module.exports = __webpack_public_path__ + "85aed1c870412a2e642c0cbdbb5962b6.png";